export default __webpack_public_path__ + "static/media/NTEX CLASS-7_SYLLABUS_2025-26.5894492e.pdf";